import { render, staticRenderFns } from "./AppraisalType.vue?vue&type=template&id=5af8f0e3"
import script from "./AppraisalType.vue?vue&type=script&lang=js"
export * from "./AppraisalType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports